import toast from 'react-hot-toast'

import { ToastNotification } from '../components/toast-notification/toast-notification'

export function groupByHelper(objectArray: any, properties: string[]) {
    return objectArray.reduce((acc: any[], obj: any) => {
        let key = obj

        properties.forEach(p => {
            key = key[p]
        })

        if (!acc[key]) {
            acc[key] = []
        }
        acc[key].push(obj)
        return acc
    }, {})
}

export function Notify(
    status: 'success' | 'danger' | 'primary' | 'default' | 'warning',
    title: string,
    message: string,
) {
    toast.custom(t => (
        <ToastNotification
            t={t}
            status={status}
            title={title}
            message={message}
        />
    ))
}

export function ellipsisString(str: string | undefined, length: number) {
    if (!str) return ''
    if (str.length < length) return str
    else return str.substr(0, length) + '...'
}

export const formatCryptoAmount = (value: number) => {
    return value.toLocaleString('en-US', { minimumFractionDigits: 4 })
}
export const formatFiatAmount = (value: number) => {
    return value.toLocaleString('en-US', { minimumFractionDigits: 2 })
}
